import { FC, useCallback, useMemo } from 'react'
import { Pagination, Table } from 'antd'
import PageLayout from '../../../components/page-layout/page-layout'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import useEndpointQueryParams from '../../../hooks/table-pages/use-endpoint-query-parameters'
import useTablePagination from '../../../hooks/table-pages/use-table-pagination'
import { useGetFormSetsQuery } from '../../../store/api/form-sets-api'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import FiltersForm from './components/filters-form/filters-form'
import { getColumns } from './constants/columns'
import { deserializeFilters } from './helpers/deserialize-filters'
import { FormsDataSource } from './helpers/forms-data-source'
import { FormsTableRow } from './types/forms-table-row'

const populate: EndpointQueryParameters['populate'] = {
    forms: {
        populate: {
            form_order: {
                populate: {
                    user_audit: {
                        populate: {
                            created_by_permissions_user: true,
                        },
                    },
                },
            },
        },
    },
}

interface FlexoFormsPageProps {}

const FlexoFormsPage: FC<FlexoFormsPageProps> = () => {
    const baseParams = useEndpointQueryParams({ deserializeFilters })
    const params: EndpointQueryParameters = useMemo(
        () => ({
            ...baseParams,
            sort: ['id:desc'],
            populate,
        }),
        [baseParams]
    )

    const { data, isLoading, refetch } = useGetFormSetsQuery(params)
    const pagination = useTablePagination(params, data)
    const dataSource = useMemo(() => FormsDataSource(data?.data ?? []), [data])
    const columns = useMemo(() => getColumns({ onRefetch: refetch }), [refetch])

    const tableFooter = useCallback(
        () => <Pagination {...pagination} size='small' align='end' />,
        [pagination]
    )

    return (
        <PageLayout title={'Флексоформы'}>
            <TableWrapper style={{ flex: 'auto' }}>
                <Table<FormsTableRow>
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    footer={tableFooter}
                    rowKey={record => record.key}
                    loading={isLoading}
                    summary={() => (
                        <Table.Summary fixed={'top'}>
                            <FiltersForm />
                        </Table.Summary>
                    )}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default FlexoFormsPage
